export default __webpack_public_path__ + "static/media/DSC02233.aaf8b845.jpeg";